exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3ck9X3Ig-Map-module-label{background-color:#fff;box-shadow:0 2px 7px 1px rgba(0,0,0,.3);font-size:20px;height:200px;opacity:1!important;padding:5px;width:450px}", ""]);

// exports
exports.locals = {
	"label": "_3ck9X3Ig-Map-module-label"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"localIdentName":"[hash:base64:8]-[name]-[local]","modules":true,"camelCase":true}!../~/postcss-loader/lib!../~/sass-loader/lib/loader.js!./js/components/pages/Inventory/InventoryMap/Map/Map.module.scss
// module id = 1202
// module chunks = 0